export default "__VITE_ASSET__zSGrDeG$__"